import { useEffect, useState } from "react";
import Styles from "./Settings.module.css";
import ReactQuill, { Quill } from "react-quill";
import { Button, Upload } from "antd";
import toast from "react-hot-toast";
import {
  AddShopScrollers,
  FetchShopScrollersService,
} from "../../../Services/ApiServices";
import { useSelector } from "react-redux";

const Settings = () => {
  const [isLoader, setIsLoader] = useState(false);
  const [value, setValue] = useState("");
  let { profile } = useSelector((state) => state);

  console.log(profile, "profile");

  const [fileList, setFileList] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  // Accept only images
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      toast.error("Only image files are allowed!");
      return Upload.LIST_IGNORE;
    }

    // Store image in state
    setSelectedImage(file);

    return false; // prevent auto upload
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "color",
    "background",
    "align",
    "list",
    "bullet",
  ];

  useEffect(() => {
    if (profile?.franchise_id) {
      getShopScrollers();
    }
  }, [profile?.franchise_id]);

  const handleFileUpload = () => {
    // if (!selectedImage) {
    //   toast.error("Please select a file before importing!");
    //   return;
    // }

    setIsLoader(true);
    const formData = new FormData();
    if (selectedImage) {
      formData.append("image", selectedImage || ""); // ✅ attach file
    }
    formData.append("text", value || "");
    formData.append("franchise_code", profile?.franchise_id);
    if (!selectedImage && fileList?.length) {
      formData.append("image_key", 1);
    }

    AddShopScrollers(formData)
      .then((res) => {
        toast.success(res?.data?.msg || "File imported successfully!");
        setFileList(null);
        setSelectedImage(null);
        getShopScrollers();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.detail?.[0]?.msg || "Something went wrong!"
        );
      })
      .finally(() => {
        setIsLoader(false);
      });
  };

  const getShopScrollers = () => {
    setIsLoader(true);

    let formData = new FormData();
    formData.append("franchise_code", profile?.franchise_id);

    FetchShopScrollersService(formData)
      .then(async (res) => {
        if (res?.data?.data?.image) {
          const imageUrl = res?.data?.data?.image;

          // Set FileList correctly
          setFileList([
            {
              uid: "-1",
              name: "uploaded image",
              status: "done",
              url: imageUrl,
            },
          ]);
        }

        // Set description text
        setValue(`${res?.data?.data?.text || ""}`);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  return (
    <>
      <div className={Styles.overallContainer + " container-fluid p-0"}>
        {isLoader ? (
          <div className={Styles.loaderParent}>
            <div className={Styles.loader}></div>
          </div>
        ) : null}{" "}
        <div className={Styles.pageWrap}>
          <p className="fontBold pt-3 pb-1 fs-4">
            Set
            <span className="orange">tings</span>
          </p>
          <div className={Styles.whiteBg}>
            <div className={Styles.field_container}>
              <div>
                <p className={Styles.label}>Description</p>
                <ReactQuill
                  theme="snow"
                  value={value}
                  onChange={setValue}
                  modules={modules}
                  formats={formats}
                  className="notepadStyle"
                />
              </div>
              <div id="settinguploadfile">
                <p className={Styles.label}>Upload Image</p>

                <Upload
                  beforeUpload={beforeUpload}
                  fileList={fileList}
                  onChange={({ fileList }) => setFileList(fileList || null)}
                  maxCount={1}
                  accept="image/*"
                  onRemove={() => {
                    setSelectedImage(null);
                    setFileList(null);
                  }}
                  listType="picture"
                >
                  <Button>Browse Image</Button>
                  <p className={Styles.shortNote}>
                    Please upload an image with Width 284px and Height 500px
                  </p>
                </Upload>
              </div>
            </div>
            <div className={Styles.btnContainer}>
              <button onClick={() => handleFileUpload()} className={Styles.btn}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Settings;
